<template>
  <section>
    <div class="modal fade" id="InsuranceRisksModal" tabindex="-1" aria-labelledby="InsuranceRisksModalLabel" aria-hidden="true" @keydown.esc="clearForm">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header p-5">
            <h5 class="modal-title" id="InsuranceRisksModalLabel">Страховые риски</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body p-0">
            <div class="custom-table">
              <div class="table-responsive">
                <table class="podft table table-striped table-hover table-row-dashed fs-7 table-row-gray-300 gy-3 mb-0 text-gray-800">
                  <thead>
                  <tr class="fw-bold fs-8 text-gray-400">
                    <th>Страховой случай</th>
                    <th class="text-end" title="Франшиза (безусловная) по каждому и любому страховому случаю (в процентах от общей страховой суммы">Франшиза (безусловная)</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td>Пожар</td>
                    <td class="text-end" v-html="risks.fire+' %'"></td>
                  </tr>
                  <tr>
                    <td>Удар молнии</td>
                    <td class="text-end" v-html="risks.lightning+' %'"></td>
                  </tr>
                  <tr>
                    <td>Взрыв</td>
                    <td class="text-end" v-html="risks.explosion+' %'"></td>
                  </tr>
                  <tr>
                    <td>Падение на имущество пилотируемых летающих объектов или их обломков, либо груза.</td>
                    <td class="text-end" v-html="risks.plane_crash+' %'"></td>
                  </tr>
                  <tr>
                    <td>Стихийные бедствия, а именно только и исключительно - оползень, горный обвал, буря, вихрь, ураган, град, ливень, снежная лавина.</td>
                    <td class="text-end" v-html="risks.natural_disasters+' %'"></td>
                  </tr>
                  <tr>
                    <td>Стихийное бедствие, а именно только и исключительно - землетрясение.</td>
                    <td class="text-end" v-html="risks.earthquake+' %'"></td>
                  </tr>
                  <tr>
                    <td>Землетрясение и последующего (вызванного им) пожара.</td>
                    <td class="text-end" v-html="risks.earthquake_fire+' %'"></td>
                  </tr>
                  <tr>
                    <td>Затопление в результате аварий водопроводных, канализационных, отопительных систем и систем пожаротушения.</td>
                    <td class="text-end" v-html="risks.flooding+' %'"></td>
                  </tr>
                  <tr>
                    <td>Противоправные действия третьих лиц, а именно только и исключительно - кража со взломом, разбой, грабеж.</td>
                    <td class="text-end" v-html="risks.third_party_actions+' %'"></td>
                  </tr>
                  <tr>
                    <td>Полная гибель/утрата в результате любого страхового случая, указанного в договоре.</td>
                    <td class="text-end" v-html="risks.total_loss+' %'"></td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="modal-footer p-3 justify-content-center">
            <button
                type="button"
                class="btn btn-sm btn-secondary"
                data-bs-dismiss="modal"
            >Закрыть</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'InsuranceRisks',
  props: {
    risks: null
  }
}
</script>

<style scoped>

</style>